import Indicator, { IndicatorType } from '../types/Indicator'

const IchimokuCloud: Indicator = {
  type: IndicatorType.OVERLAY,
  value: 'ichimokuCloud',
  label: 'Ichimoku Cloud',
  nickname: 'Ichimoku Cloud',
  fields: ['conversion', 'base', 'spanA', 'spanB'],
  params: {
    conversionPeriod: 9,
    basePeriod: 26,
    spanPeriod: 52,
    displacement: 26,
  },
}

export default IchimokuCloud
